export default "__VITE_ASSET__BuMiKNop__"